/**
  * @memberof checkVarType
  * @name isArray
  * Check if a variable is an array
  * @param {any} x variable to be checked
  * @returns {boolean} is the variable an array?
*/
const isArray = (x) => Array.isArray(x);

export default isArray;
